const LABELS = {
  EDIT: 'Editar Regra',
  FUTURE: 'Futura',
  BULK_UPDATE: 'Atualizar múltiplas'
};

export default LABELS;
